/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Spaces_Wizard_Step2_Link_TitleInputs */



/**
* | output |
* | --- |
* | "Link your {provider} account" |
*
* @param {Spaces_Wizard_Step2_Link_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step2_link_title = /** @type {((inputs: Spaces_Wizard_Step2_Link_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step2_Link_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Verknüpfe dein ${i?.provider}-Konto`)
	return /** @type {LocalizedString} */ (`Link your ${i?.provider} account`)
});